export default __webpack_public_path__ + "static/media/canvasAndFramedLargeFramedBlack.a013f0ad.jpg";